export enum EminhaGestao {
  Index = "index",
  Home = "home",
  Empresas = "empresas",
  Contas = "contas",
  Certificados = "certificados",
  Adquirentes = "adquirentes",
  Pdv = "pdv"
}
